import { render, staticRenderFns } from "./VTextfield.vue?vue&type=template&id=dd7c889a"
import script from "./VTextfield.vue?vue&type=script&lang=js"
export * from "./VTextfield.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports